import { useEffect, useState } from 'react';

import { BreedVariety, ContentItemBase } from 'pricing/types';
import { pricingContent } from 'pricing/utilities/localStorage/pricingContentStorage';
import { Nullable } from 'types';

function useBreedVarieties(breedId: Nullable<number>) {
  const [breedVarieties, setBreedVarieties] = useState<ContentItemBase[]>([]);
  const contentBreedVarieties: BreedVariety[] = pricingContent.breedVarieties;
  const contentVarieties: ContentItemBase[] = pricingContent.puppyVarieties;

  const handleSetBreedVarieties = () => {
    const getBreedVarieties = contentBreedVarieties
      .filter((breedVariety) => breedVariety.breedId === breedId)
      .map((bv) => bv.varietyId);

    const getVarieties = contentVarieties.filter((cVarieties) => {
      return getBreedVarieties.includes(cVarieties.id);
    });

    setBreedVarieties(getVarieties);
  };

  useEffect(() => {
    breedId && handleSetBreedVarieties();
  }, [breedId]);

  return {
    breedVarieties,
  };
}

export default useBreedVarieties;
